import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export enum ThreatVectorMitigationTaskPriority {
    Veryhigh = 'P01VERYHIGH',
    High = 'P02HIGH',
    Medium = 'P03MEDIUM',
    Low = 'P04LOW',
}

interface ThreatVectorMitigationTaskProps {
    id: string;
    name?: string;
    description?: string;
    deadline?: Date;
    priority?: ThreatVectorMitigationTaskPriority;
    threatVectorMitigationId?: string;
}

export class ThreatVectorMitigationTask extends Entity {
    name?: string;
    description?: string;
    deadline?: Date;
    priority?: ThreatVectorMitigationTaskPriority;
    threatVectorMitigationId?: string;

    constructor({
        id,
        name,
        description,
        deadline,
        priority,
        threatVectorMitigationId,
    }: ThreatVectorMitigationTaskProps) {
        super({ id });
        this.name = name;
        this.description = description;
        this.deadline = deadline;
        this.priority = priority;
        this.threatVectorMitigationId = threatVectorMitigationId;
    }

    static new(
        props: Omit<ThreatVectorMitigationTaskProps, 'id'>,
    ): ThreatVectorMitigationTask {
        const uuid = new UUID();
        return new ThreatVectorMitigationTask({
            id: uuid.toString(),
            ...props,
        });
    }
}
